/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
// tslint:disable:max-line-length
import * as _ from 'lodash';
const types = [{
  text: 'Public Record: Bankruptcy supporting documentation',
  type: 'LOE_PUBLIC_RECORD:BANKRUPTCY'
}, {
  text: 'Public Record: Tax lien supporting documentation',
  type: 'LOE_PUBLIC_RECORD:TAX_LIEN'
}, {
  text: 'Public Record: Judgment supporting documentation',
  type: 'LOE_PUBLIC_RECORD:JUDGMENT'
}, {
  text: 'Large Deposit: Transfer from account supporting documentation',
  type: 'LOE_LARGE_DEPOSITS:TRANSFER'
}, {
  text: 'Large Deposit: Sale of asset supporting documentation',
  type: 'LOE_LARGE_DEPOSITS:SALE_OF_ASSET'
}, {
  text: 'Large Deposit: Income supporting documentation',
  type: 'LOE_LARGE_DEPOSITS:INCOME'
}, {
  text: 'Large Deposit: Gift supporting documentation',
  type: 'LOE_LARGE_DEPOSITS:GIFT'
}, {
  text: 'Large Deposit: Other supporting documentation',
  type: 'LOE_LARGE_DEPOSITS:OTHER'
}, {
  text: 'Bank Statement',
  type: 'BANK_STATEMENT'
}, {
  text: 'Mutual Fund Account Statement',
  type: 'BANK_STATEMENT:_MUTUAL_FUND_ACCOUNT'
}, {
  text: 'Investment Account Statement',
  type: 'BANK_STATEMENT:_STOCK_ACCOUNT'
}, {
  text: 'Balance Sheet',
  type: 'FINANCIAL_STATEMENT:_BALANCE_SHEET'
}, {
  text: 'Profit and Loss Statement',
  type: 'FINANCIAL_STATEMENT:_INCOME'
}, {
  text: 'Tax Return',
  type: 'IRS1040'
}, {
  text: 'Tax Return for Estates and Trusts',
  type: 'IRS1041'
}, {
  text: 'Corporation Income Tax Return',
  type: 'IRS1120'
}, {
  text: 'S Corporation Income Tax Return',
  type: 'IRS1120_S'
}, {
  text: 'LLC Business Tax Return',
  type: 'LLC_BTR_DOC'
}, {
  text: 'W-2',
  type: 'IRSW2'
}, {
  text: 'T4',
  type: 'CRAT4'
}, {
  text: 'Signed 1003 (Residential Loan Application)',
  type: '1003'
}, {
  text: '4506-T (Request for Transcript of Tax Return)',
  type: '4506t'
}, {
  text: 'Tax Transcript',
  type: 'TAX_TRANSCRIPT'
}, {
  text: 'Docusign Certificate of Completion',
  type: 'DOCUSIGN_CERT_OF_COMP'
}, {
  text: 'Docusign Envelope History',
  type: 'DOCUSIGN_ENVELOPE_HISTORY'
}, {
  text: 'Paystub',
  type: 'PAY_STUB'
}, {
  text: 'Property Insurance Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_GENERAL'
}, {
  text: 'Mine Subsidence Insurance Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_MINE_SUBSIDENCE'
}, {
  text: 'Insect Infestation Insurance Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_INSECT_INFESTATION'
}, {
  text: 'Homeowners Insurance Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_HOMEOWNERS'
}, {
  text: 'Volcano Insurance Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_VOLCANO'
}, {
  text: 'Flood Insurance Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_FLOOD'
}, {
  text: 'Hazard Insurance Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_HAZARD'
}, {
  text: 'Insurance Agent Contact Info',
  type: 'INSURANCE_AGENT_CONTACT_INFO'
}, {
  text: 'eSignature Card',
  type: 'ESIGNATURE_CARD'
}, {
  text: 'Deposit Account Disclosure',
  type: 'DEPOSIT_ACCOUNT_DISCLOSURE'
}, {
  text: 'Deposit Account Adverse Action Notice',
  type: 'DEPOSIT_ACCOUNT_ADVERSE_ACTION_NOTICE'
}, {
  text: 'Purchase Agreement',
  type: 'PURCHASE_AGREEMENT'
}, {
  text: 'Other Disclosures',
  type: 'OTHER_DISCLOSURES'
}, {
  text: 'Request for Tax Transcript from IRS',
  type: 'REQUEST_FOR_COPY_OF_TAX_RETURN:_IRS4506_T'
}, {
  text: 'Retirement Account Statement',
  type: 'RETIREMENT_ACCOUNT_STATEMENT'
}, {
  text: 'Social Security Award Letter',
  type: 'SOCIAL_SECURITY_AWARD_LETTER'
}, {
  text: 'Trust Agreement',
  type: 'TRUST_AGREEMENT'
}, {
  text: 'Verification of Employment - Verbal',
  type: 'VERIFICATION_OF_EMPLOYMENT'
}, {
  text: 'Reverified Verification of Employment',
  type: 'VERIFICATION_OF_EMPLOYMENT_REVERIFY'
}, {
  text: 'Verification of Employment',
  type: 'VERIFICATION_OF_EMPLOYMENT_RETRIEVED'
}, {
  text: 'Verification of Income',
  type: 'VERIFICATION_OF_INCOME'
}, {
  text: 'Pension Award Letter',
  type: 'PENSION_AWARD_LETTER'
}, {
  text: 'Annuity Award Letter',
  type: 'ANNUITY_AWARD_LETTER'
}, {
  text: 'Deferred Compensation Award Letter',
  type: 'DEFERRED_COMPENSATION_AWARD_LETTER'
}, {
  text: 'Verification of Mortgage or Rent',
  type: 'VERIFICATION_OF_MORTGAGE_OR_RENT'
}, {
  text: 'Verification of Rent',
  type: 'VERIFICATION_OF_RENT'
}, {
  text: 'Verification of Mortgage',
  type: 'VERIFICATION_OF_MORTGAGE'
}, {
  text: 'Retirement Liquidity Terms',
  type: 'RETIREMENT_LIQUIDITY_TERMS'
}, {
  text: 'Letter of Explanation - Credit Inquiry',
  type: 'LETTER_OF_EXPLANATION:_CREDIT_INQUIRY'
}, {
  text: 'Letter of Explanation - Derogatory Credit',
  type: 'LETTER_OF_EXPLANATION:_DEROGATORY_CREDIT'
}, {
  text: 'Letter of Explanation - Address Verification',
  type: 'LETTER_OF_EXPLANATION:_ADDRESS_VERIFICATION'
}, {
  text: 'Letter of Explanation - Job Gap',
  type: 'LETTER_OF_EXPLANATION:_JOB_GAP'
}, {
  text: 'Letter of Explanation - Large Deposit',
  type: 'LETTER_OF_EXPLANATION:_LARGE_DEPOSITS'
}, {
  text: 'Property Tax Bill',
  type: 'PROPERTY_TAX_BILL'
}, {
  text: 'Mortgage Statement',
  type: 'MORTGAGE_STATEMENT'
}, {
  text: 'Borrower Consent Form',
  type: 'BORROWER_CONSENT_FORM'
}, {
  text: 'Borrower Consent Form for Verification of Income',
  type: 'BORROWER_INCOME_VERIFICATION_CONSENT_FORM'
}, {
  text: 'Appraisal Waiver',
  type: 'APPRAISAL_WAIVER'
}, {
  text: 'Intent to Proceed',
  type: 'INTENT_TO_PROCEED'
}, {
  text: 'Government-Issued ID',
  type: 'NATIONAL_IDENTIFICATION'
}, {
  text: 'Applicant photo',
  type: 'BORROWER_PHOTO'
}, {
  text: 'Property Insurance Policy - Homeowners Master Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_MASTERPOLICY_ASSN'
}, {
  text: 'Marriage Certificate',
  type: 'MARRIAGE_CERTIFICATE'
}, {
  text: 'Death Certificate',
  type: 'DEATH_CERTIFICATE'
}, {
  text: 'Divorce Decree',
  type: 'DIVORCE_DECREE'
}, {
  text: 'Social Security Card',
  type: 'NATIONAL_IDENTIFICATION:_SOCIAL_SECURITY_CARD'
}, {
  text: 'Condo Occupancy Certificate',
  type: 'CONDOMINIUM_OCCUPANCY_CERTIFICATE'
}, {
  text: "Homeowner's Association Certification",
  type: 'HOMEOWNERS_ASSOCIATION_CERTIFICATION'
}, {
  text: 'Bank Deposit Slip',
  type: 'BANK_DEPOSIT_SLIP'
}, {
  text: 'Hurricane Insurance Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_HURRICANE'
}, {
  text: 'Leasehold Insurance Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_LEASEHOLD'
}, {
  text: 'Personal Property Insurance Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_PERSONAL_PROPERTY'
}, {
  text: 'Storm Insurance Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_STORM'
}, {
  text: 'Tornado Insurance Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_TORNADO'
}, {
  text: 'Wind Insurance Policy',
  type: 'PROPERTY_INSURANCE_POLICY:_WIND'
}, {
  text: 'Credit Report',
  type: 'CREDIT_REPORT'
}, {
  text: 'Permanent Resident Alien Identification',
  type: 'PERMANENT_RESIDENT_IDENTIFICATION'
}, {
  text: 'Property Insurance Policy - Condominium Interior Policy - HO 6',
  type: 'PROPERTY_INSURANCE_POLICY:_CONDOMINIUM'
}, {
  text: 'Appraisal Report - Single Family',
  type: 'APPRAISAL_REPORT_SINGLE FAMILY'
}, {
  text: 'Appraisal Report - 2-4 Unit',
  type: 'APPRAISAL_REPORT_2_-_4_UNIT'
}, {
  text: 'Appraisal Report - Manufactured Home',
  type: 'APPRAISAL_REPORT_MANUFACTURED_HOME'
}, {
  text: 'Appraisal Report - Coop',
  type: 'APPRAISAL_REPORT_COOP'
}, {
  text: 'Appraisal Report - Exterior Only (Drive-by)',
  type: 'APPRAISAL_REPORT_EXTERIOR_ONLY'
}, {
  text: 'Appraisal Report - AVM - Desktop Appraisal',
  type: 'APPRAISAL_REPORT_AVM'
}, {
  text: 'Appraisal Report - Rent Survey',
  type: 'APPRAISAL_REPORT_RENT_SURVEY'
}, {
  text: 'Appraisal Report - Operating Income Schedule',
  type: 'APPRAISAL_REPORT_OPERATING_INCOME_SCHEDULE'
}, {
  text: 'Appraisal Report - Market Conditions Addendum',
  type: 'APPRAISAL_REPORT_MARKET_CONDITIONS_ADDENDUM'
}, {
  text: 'Appraisal Report - Update and/or Completion Report',
  type: 'APPRAISAL_REPORT_UPDATE_AND_OR_COMPLETION_REPORT'
}, {
  text: 'Appraisal Report - Property Condition Report',
  type: 'APPRAISAL_REPORT_PROPERTY_CONDITION_REPORT'
}, {
  text: 'Appraisal Report - Desk Review',
  type: 'APPRAISAL_REPORT_DESK_REVIEW'
}, {
  text: 'HUD-1: Settlement Statement',
  type: 'SETTLEMENT_STATEMENT_HUD1'
}, {
  text: 'Visa',
  type: 'VISA'
}, {
  text: 'Passport',
  type: 'PASSPORT'
}, {
  text: 'National Identification - Non-Permanent Resident',
  type: 'NATIONAL_IDENTIFICATION_NON_PERMANENT_RESIDENT'
}, {
  text: 'DD-214 - Certificate of Release or Discharge from Active Duty',
  type: 'DD_214'
}, {
  text: 'VA-Statement of Service',
  type: 'VA_STATEMENT_OF_SERVICE'
}, {
  text: 'VA-Certificate of Eligibility',
  type: 'VA_CERTIFICATE_OF_ELIGIBILITY'
}, {
  text: 'Credit Authorization',
  type: 'CREDIT_AUTHORIZATION'
}, {
  text: 'Fee Deposit: Credit Card Authorization',
  type: 'CREDIT_CARD_AUTHORIZATION'
}, {
  text: 'Birth Certificate',
  type: 'BIRTH_CERTIFICATE'
}, {
  text: 'Utility Bill',
  type: 'INVOICE_UTILITY_BILL'
}, {
  text: 'Address Verification - Documentation',
  type: 'ADDRESS_VERIFICATION'
}, {
  text: 'Letter of Explanation - Name Variation',
  type: 'LETTER_OF_EXPLANATION_NAME_VARIATION'
}, {
  text: 'Power of Attorney',
  type: 'POWER_OF_ATTORNEY'
}, {
  text: 'Rental or Lease Agreement',
  type: 'RENTAL_AGREEMENT'
}, {
  text: 'Rental Security Deposit',
  type: 'RENTAL_SECURITY_DEPOSIT'
}, {
  text: 'Verification of Employment - Written (WVOE)',
  type: 'VERIFICATION_OF_EMPLOYMENT_WRITTEN'
}, {
  text: 'Business License',
  type: 'BUSINESS_LICENSE'
}, {
  text: 'Form 1099 (Miscellaneous Income)',
  type: 'IRS1099'
}, {
  text: "K-1 - Partner's Share of Income, Deductions, Credits, Etc.",
  type: 'K1'
}, {
  text: 'Form 1065 (U.S. Return of Partnership Income)',
  type: 'IRS1065'
}, {
  text: "Social Security - Proof of Most Recent 2 Months' Receipt",
  type: 'SOCIAL_SECURITY_PROOF_OF_RECEIPT'
}, {
  text: 'Employment Offer Letter',
  type: 'EMPLOYMENT_OFFER_LETTER'
}, {
  text: 'Rental Income - Proof of Receipt',
  type: 'RENTAL_INCOME_PROOF_OF_RECEIPT'
}, {
  text: 'Retirement Award Letter',
  type: 'RETIREMENT_AWARD_LETTER'
}, {
  text: 'VA Benefits Award Letter',
  type: 'VA_AWARD_LETTER'
}, {
  text: 'Bonus and/or Commission Income - Documentation',
  type: 'BONUS_AND_COMMISSION_DOCUMENTATION'
}, {
  text: 'Child Support Income Verification',
  type: 'CHILD_SUPPORT_INCOME'
}, {
  text: 'Alimony Income Verification',
  type: 'ALIMONY_INCOME'
}, {
  text: 'Child Support Liability Verification',
  type: 'CHILD_SUPPORT_LIABILITY'
}, {
  text: 'Alimony Liability Verification',
  type: 'ALIMONY_LIABILITY'
}, {
  text: 'Generated Asset Statement',
  type: 'GENERATED_ASSET_STATEMENT'
}, {
  text: 'Linked Bank Statement',
  type: 'PROVIDER_BANK_STATEMENT'
}, {
  // We have deprecated this document type and migrated to VALIDATION_ERROR_GAS
  text: 'QA Generated Asset Statement',
  type: 'QA_GAS'
}, {
  text: 'GAS with Validation Error',
  type: 'VALIDATION_ERROR_GAS'
}, {
  text: 'Automatic Payment Authorization',
  type: 'ACHDEBIT_AUTHORIZATION'
}, {
  text: 'Gift Letter',
  type: 'GIFT_LETTER'
}, {
  text: 'Proof of Liquidation',
  type: 'PROOF_OF_LIQUIDATION'
}, {
  text: 'Credit Report - Non-Traditional',
  type: 'CREDIT_REPORT_NON_TRADITIONAL'
}, {
  text: 'Credit Supplement',
  type: 'CREDIT_SUPPLEMENT'
}, {
  text: 'Bankruptcy Discharge Notice',
  type: 'BANKRUPTCY_DISCHARGE_NOTICE'
}, {
  text: 'Bankruptcy Filing',
  type: 'BANKRUPTCY_FILING'
}, {
  text: 'Title - Lien Release',
  type: 'SATISFACTION_OF_SECURITY_INSTRUMENT_LIEN_RELEASE'
}, {
  text: 'Fraud Alert',
  type: 'FRAUD_ALERT'
}, {
  text: 'Credit Card or Installment Account Statement',
  type: 'STATEMENT_CREDIT_CARD_OR_INSTALLMENT_ACCT'
}, {
  text: 'Judgment Documentation',
  type: 'JUDGMENT'
}, {
  text: 'Cosigned Liability Documentation',
  type: 'COSIGNED_LIABILITY'
}, {
  text: 'Purchase Agreement - Addendum',
  type: 'PURCHASE_AGREEMENT_ADDENDUM'
}, {
  text: 'Home Inspection Report',
  type: 'HOME_INSPECTION_REPORT'
}, {
  text: 'Pest Inspection Report',
  type: 'PEST_INSPECTION_REPORT'
}, {
  text: 'Roof Inspection Report',
  type: 'ROOF_INSPECTION_REPORT'
}, {
  text: 'Pool Inspection Report',
  type: 'POOL_INSPECTION_REPORT'
}, {
  text: 'Earnest Money Deposit',
  type: 'EARNEST_MONEY_DEPOSIT'
}, {
  text: 'Flood Hazard Notice',
  type: 'FLOOD_HAZARD_NOTICE'
}, {
  text: 'Flood Certification',
  type: 'FLOOD_CERTIFICATION'
}, {
  text: 'Tax Certificate',
  type: 'TAX_CERTIFICATE'
}, {
  text: 'FHA Amendatory Clause',
  type: 'AMENDATORY_CLAUSE'
}, {
  text: 'Payoff Statement',
  type: 'PAYOFF_STATEMENT'
}, {
  text: 'Closing Protection Letter (CPL)',
  type: 'CLOSING_PROTECTION_LETTER'
}, {
  text: 'Schedule of Real Estate',
  type: 'SCHEDULE_OF_REAL_ESTATE'
}, {
  text: 'Borrower Certification',
  type: 'BORROWER_CERTIFICATION'
}, {
  text: 'Occupancy Certification',
  type: 'OCCUPANCY_CERTIFICATION'
}, {
  text: 'Truth-In-Lending (TIL)',
  type: 'TRUTH_IN_LENDING'
}, {
  text: 'Good Faith Estimate',
  type: 'GOOD_FAITH_ESTIMATE'
}, {
  text: 'Escrow Waiver',
  type: 'ESCROW_WAIVER'
}, {
  text: 'Loan Estimate (LE)',
  type: 'LOAN_ESTIMATE'
}, {
  text: 'Closing Disclosure (CD)',
  type: 'CLOSING_DISCLOSURE'
}, {
  text: 'General Loan Acknowledgment Disclosure (GLAD)',
  type: 'GENERAL_LOAN_ACKNOWLEDGMENT'
}, {
  text: 'Hud/VA Addendum',
  type: 'HUD_VA_ADDENDUM'
}, {
  text: 'Letter of Explanation - General',
  type: 'BORROWER_CORRESPONDENCE:_LETTER_OF_EXPLANATION'
}, {
  text: 'Letter of Explanation - Occupancy',
  type: 'BORROWER_CORRESPONDENCE:_LETTER_OF_EXPLANATION_OCCUPANCY'
}, {
  text: 'Letter of Explanation - Cash-Out',
  type: 'BORROWER_CORRESPONDENCE:_LETTER_OF_EXPLANATION_CASHOUT'
}, {
  text: 'Mortgage Insurance',
  type: 'MORTGAGE_INSURANCE'
}, {
  text: 'Net Tangible Benefit Worksheet',
  type: 'NET_TANGIBLE_BENEFIT'
}, {
  text: 'Mortgage Note',
  type: 'NOTE'
}, {
  text: "Homeowner's Association Bill",
  type: 'HOA_BILL'
}, {
  text: 'Articles of Incorporation',
  type: 'ARTICLES_OF_INCORPORATION'
}, {
  text: 'Bylaws or Operating Agreement',
  type: 'BYLAWS_OPERATING_AGREEMENT'
}, {
  text: 'Affiliated Business Arrangement Disclosure',
  type: 'AFFILIATED_BUSINESS_ARRANGEMENT_DISCLOSURE'
}, {
  text: 'Disclosures Audit Report',
  type: 'DISCLOSURES_AUDIT_REPORT'
}, {
  text: 'Document Package Audit Report',
  type: 'DOCUMENT_PACKAGE_AUDIT_REPORT'
}, {
  text: 'Disclosures Tracking Report',
  type: 'DISCLOSURES_TRACKING_REPORT'
}, {
  text: 'Energy Efficient Mortgage Worksheet',
  type: 'ENERGY_EFFICIENT_MORTGAGE_WORKSHEET'
}, {
  text: 'Important Notice to Homebuyer',
  type: 'IMPORTANT_NOTICE_TO_HOMEBUYER'
}, {
  text: 'Fair Lending Notice',
  type: 'FAIR_LENDING_NOTICE'
}, {
  text: 'Home Inspection Notice',
  type: 'FOR_YOUR_PROTECTION_HOME_INSPECTION'
}, {
  text: 'Rate Lock Agreement',
  type: 'RATE_LOCK_AGREEMENT'
}, {
  text: 'Bond Certificate',
  type: 'BOND_CERTIFICATE'
}, {
  text: 'Customer Identification Form',
  type: 'CUSTOMER_IDENTIFICATION_VERIFICATION'
}, {
  text: 'Verification of SSN Form',
  type: 'VERIFICATION_OF_SSN'
}, {
  text: 'Residual Income Letter',
  type: 'RESIDUAL_INCOME_LETTER'
}, {
  text: 'Other',
  type: 'OTHER'
}, {
  text: 'Desktop Underwriter Output',
  type: 'DU_UNDERWRITING_FINDINGS'
}, {
  text: 'Desktop Underwriter Log',
  type: 'DU_UNDERWRITING_LOG'
}, {
  text: 'Desktop Underwriter Defaults',
  type: 'DU_UNDERWRITING_DEFAULTS'
}, {
  text: 'LPA Output',
  type: 'LPA_UNDERWRITING_FINDINGS'
}, {
  text: 'Other',
  type: 'OTHER_APPLICATION'
}, {
  text: 'Pre-Approval Letter',
  type: 'PRE_QUALIFICATION_LETTER'
}, {
  text: 'Appraisal',
  type: 'APPRAISAL'
}, {
  text: 'Pre-Approval Letter (DU)',
  type: 'PRE_APPROVAL_LETTER_DU'
}, {
  text: 'Pre-Approval Letter (LPA)',
  type: 'PRE_APPROVAL_LETTER_LPA'
}, {
  text: 'Pre-Approval Letter',
  type: 'PRE_APPROVAL_LETTER'
}, {
  text: 'Pre-Approval Letter Preview',
  type: 'PRE_APPROVAL_LETTER:_PREVIEW'
}, {
  text: 'Buying Power Audit Log',
  type: 'BUYING_POWER_AUDIT_LOG'
}, {
  text: 'Compliance Report',
  type: 'COMPLIANCE_REPORT'
}, {
  text: 'eConsent Report',
  type: 'ECONSENT_REPORT'
}, {
  text: 'Loan Snapshot',
  type: 'LOAN_SNAPSHOT'
}, {
  text: 'HMDA Report',
  type: 'HMDA_REPORT'
}, {
  text: 'Document Request Attachment',
  type: 'ATTACHMENT'
}, {
  text: 'Generated Letter of Explanation - Credit Inquiry',
  type: 'LETTER_OF_EXPLANATION:_GENERATED_CREDIT_INQUIRY'
}, {
  text: 'Generated Letter of Explanation - Address Verification',
  type: 'LETTER_OF_EXPLANATION:_GENERATED_ADDRESS_VERIFICATION'
}, {
  text: 'Generated Gift Letter',
  type: 'GENERATED_GIFT_LETTER'
}, {
  text: 'Generated Letter of Explanation - Late Payment',
  type: 'LETTER_OF_EXPLANATION:_GENERATED_LATE_PAYMENT'
}, {
  text: 'Generated Letter of Explanation - Public Record',
  type: 'LETTER_OF_EXPLANATION:_GENERATED_PUBLIC_RECORD'
}, {
  text: 'Generated Letter of Explanation - Large Deposit',
  type: 'LETTER_OF_EXPLANATION:_GENERATED_LARGE_DEPOSIT'
}, {
  text: 'Medical Residency or Fellowship',
  type: 'MEDICAL_RESIDENCY_FELLOWSHIP'
}, {
  text: 'Medical License or Diploma',
  type: 'MEDICAL_LICENSE_DIPLOMA'
}, {
  text: 'Nearest Living Relative',
  type: 'NEAREST_LIVING_RELATIVE'
}, {
  text: 'Employment Contract',
  type: 'EMPLOYMENT_CONTRACT'
}, {
  text: 'Generated Cost Worksheet',
  type: 'GENERATED_COST_WORKSHEET'
}, {
  text: 'FNMA NetPay Asset Report',
  type: 'FNMA_NETPAY_REPORT_ASSETS'
}, {
  text: 'FNMA NetPay Income Worksheet',
  type: 'FNMA_NETPAY_REPORT_INCOME'
}, {
  text: 'FNMA NetPay Borrowers Request',
  type: 'FNMA_NETPAY_BORROWERS_REQUEST'
}, {
  text: 'FNMA NetPay GSE API XML Response',
  type: 'FNMA_NETPAY_GSE_API_XML'
}, {
  text: 'Know Your Customer (KYC)',
  type: 'KNOW_YOUR_CUSTOMER'
}, {
  text: 'Auto Loan Closing',
  type: 'BORROWER_AGREEMENT'
}, {
  text: 'Transaction Receipt',
  type: 'TRANSACTION_RECEIPT'
}, {
  text: 'Debt Consolidation Letter',
  type: 'GENERATED_DEBT_CONSOLIDATION_LETTER'
}, {
  text: 'Secondary ID',
  type: 'SECONDARY_IDENTIFICATION'
}, {
  text: 'Closing Package',
  type: 'CLOSING_PACKAGE'
}, {
  text: 'Promissory Note',
  type: 'PROMISSORY_NOTE'
}, {
  text: 'Deed Of Trust',
  type: 'DEED_OF_TRUST'
}, {
  text: 'Title Document',
  type: 'TITLE_DOCUMENT'
}, {
  text: 'Settlement Document Only - Not Viewable by Borrowers',
  type: 'CLOSING_SETTLEMENT_ONLY'
}, {
  text: 'Additional Closing Document',
  type: 'ADDITIONAL_CLOSING_DOCUMENT'
}, {
  text: 'Preliminary Closing Documents',
  type: 'PRELIMINARY_CLOSING_DOCUMENTS'
}, {
  text: 'Signed Closing Documents',
  type: 'SIGNED_CLOSING_DOCUMENTS'
}, {
  text: 'Trailing Documents',
  type: 'TRAILING_DOCUMENTS'
}, {
  text: 'Other Closing Documents',
  type: 'OTHER_CLOSING_DOCUMENTS'
}, {
  text: 'Adverse Action Notice',
  type: 'ADVERSE_ACTION_NOTICE'
}, {
  text: 'Loan Modification Document',
  type: 'LOAN_MODIFICATION_DOCUMENT'
}, {
  text: 'Fair Credit Reporting Act Notice',
  type: 'RATE_CHECK_FCRA_NOTICE'
}, {
  text: 'Adverse Action Notice',
  type: 'RATE_CHECK_ADVERSE_ACTION_NOTICE'
}, {
  text: 'Reg B Notice',
  type: 'RATE_CHECK_REGULATION_B'
}, {
  text: 'Title - Commitment / Prelim',
  type: 'TITLE:COMMITMENT'
}, {
  text: 'Title - Property Report',
  type: 'TITLE:_PROPERTY_REPORT'
}, {
  text: 'Title - Closing Protection Letter (CPL)',
  type: 'TITLE:_CLOSING_PROTECTION_LETTER'
}, {
  text: 'Title - Wiring Instructions',
  type: 'TITLE:_WIRING_INSTRUCTIONS'
}, {
  text: 'Title - Errors & Omissions (E&O)',
  type: 'TITLE:_ERRORS_AND_OMISSIONS'
}, {
  text: 'Title - Lien / Judgment Supporting Document',
  type: 'TITLE:_LIEN_JUDGMENT_SUPPORTING_DOC'
}, {
  text: 'Title - Tax Supporting Document',
  type: 'TITLE:_TAX_SUPPORTING_DOC'
}, {
  text: 'Title - 24-Month Chain of Title',
  type: 'TITLE:_CHAIN_OF_TITLE'
}, {
  text: 'Title - Other',
  type: 'TITLE:OTHER'
}, {
  text: 'Blend Income Verification',
  type: 'BLEND_INCOME_VERIFICATION'
}, {
  text: 'Blend Income Consent',
  type: 'BLEND_INCOME_CONSENT'
}, {
  text: 'Contractor Bid Estimates',
  type: 'CONTRACTOR_BID'
}, {
  text: 'Annuity Income',
  type: 'ANNUITY_INCOME'
}, {
  text: 'Pension',
  type: 'PENSION'
}, {
  text: 'Purchase Agreement',
  type: 'PURCHASE_AGREEMENT'
}, {
  text: 'Purchase Agreement - Addendum',
  type: 'PURCHASE_AGREEMENT_ADDENDUM'
}, {
  text: 'Earnest Money Deposit',
  type: 'EARNEST_MONEY_DEPOSIT'
}];
const validTypes = _.map(types, 'type');
export const DOCUMENT_TYPES = _.extend({
  ALL: validTypes
}, _.zipObject(validTypes, validTypes));
export const DOCUMENT_TYPE_NAMES = validTypes;
export const DOCUMENT_DEFINITIONS = types;
export const ATTORNEY_VIEWABLE_DOCUMENT_TYPES = ['CLOSING_PACKAGE', 'TITLE_DOCUMENT', 'ADDITIONAL_CLOSING_DOCUMENT'];
export const TITLE_WIRE_INSTRUCTIONS_DOC_TYPE = 'TITLE:_WIRING_INSTRUCTIONS';
export const TITLE_COMMITMENT_DOC_TYPE = 'TITLE:COMMITMENT';
export const TITLE_PROPERTY_REPORT_DOC_TYPE = 'TITLE:_PROPERTY_REPORT';
export const CLOSING_PACKAGE_DOC_TYPE = 'CLOSING_PACKAGE';
export const TITLE_PURCHASE_DOC_TYPES = ['PURCHASE_AGREEMENT', 'PURCHASE_AGREEMENT_ADDENDUM', 'EARNEST_MONEY_DEPOSIT'];
export const PRELIMINARY_CLOSING_DOC_TYPE = 'PRELIMINARY_CLOSING_DOCUMENTS';